import { StatusBar } from "expo-status-bar";
import React from "react";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  FlatList,
  TextInput,
  UIManager,
  Platform,
  RefreshControl,
} from "react-native";
import Animated from "react-native-reanimated";
const { multiply, sub } = Animated;
import Text from "app/components/Text";
import * as RootNavigation from "app/utils/RootNavigation.js";
import ValueListItem from "app/components/ValueListItem";
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import storageActions from "app/utils/storageActions";
import textHelpers from "app/utils/textHelpers";
import { styleSheet, colors, sizes, WIDTH } from "app/utils/styleSheet";
import valueHelpers from "app/utils/valueHelpers";

import DraggableFlatList from "react-native-draggable-flatlist";
import SwipeableItem from "react-native-swipeable-item";
import QuickComposer from "app/components/QuickComposer";
import Autocomplete from "app/components/Autocomplete";
import { Ionicons, Feather } from "@expo/vector-icons";

import { TouchableOpacity as RNGHTouchableOpacity } from "react-native-gesture-handler";
const isAndroid = Platform.OS === "android";
if (isAndroid && UIManager.setLayoutAnimationEnabledExperimental) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}
const PlatformTouchable = isAndroid ? TouchableOpacity : TouchableOpacity;

import store from "app/redux/store";

export default class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      refreshing: false,
      parentQuery: "",
      values: props.values || [],
    };
  }

  static defaultProps = {
    // values: [],
    ids: [],
  };

  async componentDidUpdate(prevProps) {
    let { values } = this.props;
    if (!!values?.length && !prevProps.values?.length) {
      this.setState({ values: values });
    }
  }

  async componentDidMount() {
    if (this.props.values === undefined) {
      let { values } = store.getState();
      console.log("fetching valuessssssssssss");
      this.setState({ values });
    }
  }

  itemRefs = new Map();

  refresh = async () => {
    // await this.fetch()
    // this.setState({refreshing: false})
  };

  render() {
    let { ids, loading, quickComposer } = this.props;
    let { fetching, values } = this.state;

    let allValues = values || [];
    let safeIds = ids || [];
    values = allValues.filter((v) => safeIds.includes(v.id));

    // let values = allValues.filter(v => ids.includes(v.id))
    values = values.map((v) => ({ ...v, key: v.id }));

    // order values by ids array
    let order = {};
    safeIds.forEach((id, i) => (order[id] = i));
    values.sort((a, b) => order[a.id] - order[b.id]);

    return (
      <View style={styles.wrapper}>
        <FlatList
          //<DraggableFlatList
          // refreshControl={ // this interferes with draggable ordering
          //   <RefreshControl refreshing={refreshing} onRefresh={this.refresh} />
          // }
          style={{ flex: 1 }}
          activationDistance={15}
          data={values}
          extraData={values.length}
          ListFooterComponent={<View style={{ height: sizes.base }} />}
          // ListHeaderComponent={(
          //   this.renderItem({item: {key: 'composer'}},
          //     this.renderComposer,
          //     this.renderComposerUnderlayLeft,
          //     this.renderComposerUnderlayRight,
          //   )
          // }
          ListHeaderComponent={
            quickComposer && (
              <View style={styles.inputRow}>
                <QuickComposer
                  ref={(ref) => (this.composer = ref)}
                  fetching={fetching || loading}
                  onSubmit={this.props.onSubmit}
                  // onPress={close}
                  // pointerEvents={!!openDirection ? 'box-only' : 'auto'}
                />
              </View>
            )
          }
          keyExtractor={(item, index) => `draggable-item-${item.key}`}
          onDragEnd={async ({ data }) => {
            if (this.props.onSortIds) {
              let values = data;
              let ids = values.map((v) => v.id);
              this.props.onSortIds(ids);
            }
          }}
          renderItem={this.renderItem}
        />
        {ENV.WEB && this.props.onSortIds && this.renderSortingCol(values)}
      </View>
    );
  }

  renderItem = (
    { item, index, drag, isActive },
    renderOverlay = null,
    renderUnderlayLeft = null,
    renderUnderlayRight = null
  ) => {
    let value = item;
    item.hasLeft = true;
    item.hasRight = true;

    // if(!renderUnderlayLeft){
    //   item.hasLeft = value.child_ids.length
    // } else item.hasLeft = true
    // if(!renderUnderlayRight){
    //   item.hasRight = value.parent_ids.length
    // } else item.hasRight = true

    let listWidth = Math.min(WIDTH, 500);

    return (
      <View style={{ marginTop: sizes.base }}>
        {this.renderOverlay({ item: { item: value } })}
        {/*<SwipeableItem
          key={item.key}
          item={{ item, drag }}
          ref={ref => {
            if (ref && !this.itemRefs.get(item.key)) {
              this.itemRefs.set(item.key, ref);
            }
          }}
          onChange={({ open }) => {
            if (open) {
              // Close all other open items
              [...this.itemRefs.entries()].forEach(([key, ref]) => {
                if (key !== item.key && ref) ref.close();
              });
            }
          }}
          overSwipe={50}
          // snapPointsLeft={item.hasLeft ? [50, listWidth/2] : undefined}
          // snapPointsRight={item.hasRight ? [100, listWidth/2] : undefined}
          snapPointsLeft={item.hasLeft ? [listWidth/4] : undefined}
          snapPointsRight={item.hasRight ? [listWidth/4] : undefined}
          renderUnderlayLeft={renderUnderlayLeft || this.renderUnderlayLeft}
          renderUnderlayRight={renderUnderlayRight || this.renderUnderlayRight}
          renderOverlay={renderOverlay || this.renderOverlay}
        />*/}
      </View>
    );
  };

  renderOverlay = ({ item, openLeft, openRight, openDirection, close }) => {
    // const { text, backgroundColor, hasLeft, hasRight } = item.item;
    let { onCreate, onComplete, onCancel, onUpdate, hiddenIds, noDrag } =
      this.props;
    let value = item.item;
    // console.log(item)
    return (
      <ValueListItem
        value={value}
        pointerEvents={!!openDirection ? "box-only" : "auto"}
        // onPress={() => {
        //   if(!!openDirection) close()
        //   else RootNavigation.push('Value', {value, id: value.id})
        // }}
        onPress={!!openDirection ? () => close() : undefined}
        onUpdate={!!onUpdate ? onUpdate() : undefined}
        // move to parent comp
        onSubmit={(longPress) =>
          onComplete ? onComplete(value, longPress) : null
        }
        onCancel={() => (onCancel ? onCancel(value) : null)}
        loading={value.loading}
        onLongPress={noDrag ? undefined : item.drag}
        style={
          item.item.isActive
            ? { borderWidth: 2, borderColor: colors.trim }
            : null
        }
        onPressRight={openLeft}
        onPressLeft={openRight}
        hideButtons={this.props.hideButtons}
        showDueDate={this.props.showDueDates}
        showAncestorIcons={this.props.showAncestorIcons}
        customIcon={this.props.customIcon}
      />
    );
  };

  renderUnderlayLeft = ({ item, percentOpen, close }) => {
    return (
      <Animated.View
        style={[
          styles.row,
          styles.underlayLeft,
          { opacity: percentOpen },
          { transform: [{ translateX: multiply(sub(1, percentOpen), 100) }] }, // Translate from right on open
        ]}
      >
        <PlatformTouchable onPressOut={() => this.viewChildren(item.item)}>
          <Text>Children</Text>
        </PlatformTouchable>
      </Animated.View>
    );
  };

  renderUnderlayRight = ({ item, percentOpen, close }) => (
    <Animated.View
      style={[
        styles.row,
        styles.underlayRight,
        { opacity: percentOpen },
        { transform: [{ translateX: multiply(sub(1, percentOpen), -100) }] }, // Translate from left on open
      ]}
    >
      <PlatformTouchable onPressOut={() => this.viewParents(item.item)}>
        <Text>Parents</Text>
      </PlatformTouchable>
    </Animated.View>
  );

  renderComposer = (params) => {
    let { openDirection, close } = params;
    let { allValues, loading } = this.props;
    let { fetching } = this.state;
    return (
      <View style={styles.inputRow}>
        <QuickComposer
          ref={(ref) => (this.composer = ref)}
          fetching={fetching || loading}
          values={allValues}
          onSubmit={this.props.onSubmit}
          onPress={close}
          pointerEvents={!!openDirection ? "box-only" : "auto"}
        />
      </View>
    );
  };

  renderComposerUnderlayLeft = ({ item, percentOpen, close }) => {
    return (
      <Animated.View
        style={[
          styles.row,
          styles.underlayLeft,
          { opacity: percentOpen },
          { transform: [{ translateX: multiply(sub(1, percentOpen), 100) }] }, // Translate from right on open
        ]}
      >
        <PlatformTouchable onPressOut={close}>
          <Text>ADD Children!</Text>
        </PlatformTouchable>
      </Animated.View>
    );
  };

  renderComposerUnderlayRight = ({ item, percentOpen, close }) => (
    <Animated.View
      style={[
        styles.row,
        styles.underlayRight,
        { opacity: percentOpen },
        { transform: [{ translateX: multiply(sub(1, percentOpen), -100) }] }, // Translate from left on open
      ]}
    >
      {/*<PlatformTouchable onPressOut={close}>*/}
      <View>
        <ValueListItem
          // pointerEvents={this.props.pointerEvents}
          value={{}}
          icon={"flow-tree"}
          iconColor={colors.placeholder}
          onPress={() => !!this.addParentsInput && this.addParentsInput.focus()}
          hideButtons
          onSubmit={close}
          onCancel={() => alert("clear all?")}
          renderButton={(style) => {
            return (
              <Feather
                name={"edit"}
                color={colors.lightForeground}
                style={style}
                onPress={() => this.setState({ composing: true })}
              />
            );
          }}
          renderText={() => (
            <Autocomplete
              // autoFocus
              inputRef={(c) => (this.addParentsInput = c)}
              placeholder={"add parents"}
              placeholderTextColor={colors.placeholder}
              extraStyle={styles.bigInput}
              value={this.state.parentQuery || ""}
              data={textHelpers.suggestions(
                this.state.parentQuery,
                this.props.allValues
              )}
              onChangeText={(text) => this.setState({ parentQuery: text })}
              // renderItem={({ item, i }) => (
              //   <PlatformTouchable onPress={() => this.selectParent(item)}>
              //     <Text>{item.text}{value.parent_ids.includes(item.id) ? ' ✓' : null}</Text>
              //   </PlatformTouchable>
              // )}
              onCancel={() => this.setState({ parentQuery: "" })}
              onSubmit={() => {
                alert("complete?");
              }}
              onChangeText={(text) => {
                this.setState({ parentQuery: text });
              }}
              renderItem={({ item, i }) => (
                <PlatformTouchable key={i} onPress={() => alert(item)}>
                  <Text style={{ padding: sizes.small }}>{item.text}</Text>
                </PlatformTouchable>
              )}
            />
          )}
          renderFooter={() => {
            // maybe show selected parent icons here?
          }}
        />
      </View>
    </Animated.View>
  );

  renderSortingCol = (values) => {
    return null;
    return (
      <View
        style={{
          width: 50,
          flexDirection: "column",
          paddingTop: 140,
        }}
      >
        {values.map((value, i) => (
          <View
            key={i}
            style={{
              height: 122,
              paddingVertical: 10,
              justifyContent: "space-around",
              alignItems: "center",
              // borderWidth: 1, borderColor: 'white',
            }}
          >
            <TouchableOpacity
              onPress={async () => {
                if (i == 0) return;
                values.splice(i, 1);
                values.splice(i - 1, 0, value);
                let ids = values.map((v) => v.id);
                this.props.onSortIds(ids);
              }}
            >
              <Text style={{ fontSize: 16 }}>^</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={async () => {
                if (i == values.length - 1) return;
                values.splice(i, 1);
                values.splice(i + 1, 0, value);
                let ids = values.map((v) => v.id);
                this.props.onSortIds(ids);
              }}
            >
              <Text style={{ fontSize: 12 }}>v</Text>
            </TouchableOpacity>
          </View>
        ))}
      </View>
    );
  };

  viewParents = (value) => {
    alert("needs review");
    return;
    let ids = value.parent_ids;
    RootNavigation.push("List", { ids });
  };

  viewChildren = (value) => {
    alert("needs review");
    return;
    let ids = value.child_ids;
    RootNavigation.push("List", { ids });
  };
}

const styles = StyleSheet.create({
  wrapper: {
    // flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-start",
    // alignSelf: 'center',
    width: "100%",
    maxWidth: 500,
    alignSelf: "center",
    // alignItems: 'stretch',
    // overflow: 'hidden',
    // backgroundColor: colors.empty,
    // backgroundColor: 'red',
    // paddingBottom: sizes.large,
  },
  inputRow: {
    zIndex: 2,
    flex: 1,
    // borderWidth: 3, borderColor: 'red',
    // marginBottom: sizes.base,
  },
  list: {
    // flex: 1,
    // borderWidth: 3, borderColor: 'green',
    // position: 'relative',
    // left: -(sizes.giant * levelsDeep),
  },

  row: {
    flexDirection: "row",
    flex: 1,
    alignItems: "center",
    justifyContent: "space-around",
    // padding: 15
  },
  underlayRight: {
    flex: 1,
    // backgroundColor: "teal",
    justifyContent: "flex-start",
  },
  underlayLeft: {
    flex: 1,
    // backgroundColor: "tomato",
    justifyContent: "flex-end",
  },

  bigInput: {
    color: colors.foreground,
    backgroundColor: "transparent",
    // marginBottom: 0,
    // lineHeight: sizes.itemHeight,
    textAlignVertical: "center",
    height: sizes.itemHeight,
  },
});
